import { AbstractControl } from "@angular/forms";

export function ksaZipCodeValidator(control: AbstractControl): { ksaZipCode?: boolean; ksaLength?: boolean } | null {
	if (!control.value) {
		return null;
	}

	const requiredLength = 6;
	const validIndex = 4;

	const string = control.value.toUpperCase();
	const trimmedString = string.replace(/\s/, "");
	const spaceIndex = string.indexOf(" ");

	if (trimmedString.length > 0 && trimmedString.length < requiredLength) {
		return { ksaLength: false };
	}

	if (trimmedString.length > requiredLength) {
		return { ksaLength: false };
	}

	if (spaceIndex !== -1 && spaceIndex !== validIndex) {
		return { ksaZipCode: false };
	}

	const regex = {
		onlyLetters: /^[A-Za-z]+$/,
		onlyNumbers: /^[0-9]+$/,
	};

	const firstFourNumbers = trimmedString.substring(0, 4);
	const lastTwoLetters = trimmedString.substring(4, 6);

	if (regex.onlyNumbers.test(firstFourNumbers) && regex.onlyLetters.test(lastTwoLetters)) {
		return null;
	}

	return { ksaZipCode: false };
}
